import { IPage } from "../interface/page";
import axiosInstance from "./instance";

export const RequestGetPages = (addNotification: any, data?: any): Promise<IPage[]> => {
    return new Promise<IPage[]>((resolve, reject) => {
        let url = `/pages/`;
        if (data) {
            url += "?";
            for (let [key, value] of Object.entries(data)) {
                url += key + '=' + value + "&";
            }
        }
        axiosInstance(addNotification).get(url).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            // console.log(response);
            resolve(response)

        }).catch(exc => {
            // console.log(exc);
            reject(exc);
        });
    })
}

export const RequestGetPage = (addNotification: any, id: string): Promise<IPage> => {
    return new Promise<IPage>((resolve, reject) => {

        axiosInstance(addNotification).get(`/pages/${id}`).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            //  console.log(response);
            resolve(response)

        }).catch(exc => {
            //   console.log(exc);
            reject(exc);
        });
    })
}


export const RequestNewPage = (addNotification: any, thing: IPage): Promise<IPage> => {
    return new Promise<IPage>((resolve, reject) => {

        axiosInstance(addNotification).post(`/pages/`, thing).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            console.log(response);
            resolve(response)

        }).catch(exc => {
            console.log(exc);
            reject(exc);
        });
    })
}
export const RequestDeletePage = (addNotification: any, thing: IPage): Promise<boolean> => {
    return new Promise<boolean>((resolve, reject) => {

        axiosInstance(addNotification).delete(`/pages/delete/${thing.id}`).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            console.log(response);
            resolve(response)

        }).catch(exc => {
            console.log(exc);
            reject(exc);
        });
    })
}
export const RequestUpdatePage = (addNotification: any, user: IPage): Promise<IPage> => {
    return new Promise<IPage>((resolve, reject) => {

        axiosInstance(addNotification).patch(`/pages/${user.id}`, user).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            console.log(response);
            resolve(response)

        }).catch(exc => {
            console.log(exc);
            reject(exc);
        });
    })
}

// eslint-disable-next-line
    {/*<!-- OPTIONAL 1 -->*/ }

    // eslint-disable-next-line
    {/*<!-- OPTIONAL END -->*/ }
